/* =========================================================
   FERALE CORE – wspólna logika funkcji sklepu
   (koszyk, pasek dostawy, licznik wysyłki, ulubione,
    ostatnio oglądane, kalkulator rozmiaru, quiz, zestaw,
    odliczanie do terminu)
   ========================================================= */
const FX = (window.FeraleConfig = window.FeraleConfig || {});
const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'PLN';

let EventsLib = null;
try {
  EventsLib = await import('@shopify/events');
} catch (e) {
  EventsLib = null;
}

/* ---------- helpers ---------- */
export function money(cents) {
  try {
    return new Intl.NumberFormat('pl-PL', { style: 'currency', currency }).format((cents || 0) / 100);
  } catch (e) {
    return ((cents || 0) / 100).toFixed(2).replace('.', ',') + ' zł';
  }
}
const esc = (s) =>
  String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
const store = {
  get(k, d) {
    try {
      const v = JSON.parse(localStorage.getItem(k));
      return v == null ? d : v;
    } catch (e) {
      return d;
    }
  },
  set(k, v) {
    try {
      localStorage.setItem(k, JSON.stringify(v));
    } catch (e) {}
  },
};
const plural = (n, one, few, many) => {
  if (n === 1) return one;
  const m10 = n % 10, m100 = n % 100;
  return m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14) ? few : many;
};
function imgUrl(src, width) {
  if (!src) return '';
  let u = typeof src === 'string' ? src : src.src || '';
  if (u.startsWith('//')) u = 'https:' + u;
  return u + (u.includes('?') ? '&' : '?') + 'width=' + width;
}

/* ---------- koszyk: dodawanie ---------- */
const cartListeners = new Set();
export function onCartChange(fn) {
  cartListeners.add(fn);
}
let cartFetchTimer = null;
export async function refreshCart() {
  try {
    const cart = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
    FX.cart = cart;
    cartListeners.forEach((fn) => {
      try {
        fn(cart);
      } catch (e) {}
    });
    return cart;
  } catch (e) {
    return null;
  }
}
function scheduleRefresh() {
  clearTimeout(cartFetchTimer);
  cartFetchTimer = setTimeout(refreshCart, 350);
}
/* nasłuch każdej zmiany koszyka (Horizon, aplikacje, nasze przyciski) */
if (!window.__fxFetchPatched) {
  window.__fxFetchPatched = true;
  const orig = window.fetch.bind(window);
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const p = orig(input, init);
    if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(scheduleRefresh, scheduleRefresh);
    return p;
  };
}

export async function addToCart(items, sourceEl) {
  const sectionIds = [...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId).filter(Boolean);
  const Ev = EventsLib && EventsLib.CartLinesUpdateEvent;
  let deferred = null;
  if (Ev) {
    try {
      deferred = Ev.createPromise();
      (sourceEl || document).dispatchEvent(
        new Ev({
          action: 'add',
          context: 'product',
          lines: items.map((i) => ({ merchandiseId: String(i.id), quantity: i.quantity || 1 })),
          promise: deferred.promise,
        })
      );
    } catch (e) {
      deferred = null;
    }
  }
  try {
    const body = { items: items.map((i) => ({ id: Number(i.id), quantity: i.quantity || 1, properties: i.properties || undefined })) };
    if (sectionIds.length) body.sections = sectionIds.join(',');
    const res = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body),
    }).then((r) => r.json());
    if (res.status) throw new Error(res.description || res.message || 'Nie udało się dodać do koszyka');
    const cart = await refreshCart();
    if (deferred && cart) {
      deferred.resolve({
        cart: Ev.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          source: 'ferale',
          sourceId: 'fx-' + items.map((i) => i.id).join('-'),
          itemCount: items.reduce((a, i) => a + (i.quantity || 1), 0),
          productId: sourceEl && sourceEl.dataset ? sourceEl.dataset.productId : undefined,
          sections: res.sections,
          didError: false,
        },
      });
    } else if (!deferred) {
      window.location.href = root + 'cart';
    }
    return { ok: true, cart };
  } catch (err) {
    if (deferred) deferred.reject(err);
    return { ok: false, error: err };
  }
}

function setBtnState(btn, state, msg) {
  const label = btn.querySelector('[data-fx-label]') || btn.querySelector('.fx-card__quick-label');
  btn.classList.remove('is-loading', 'is-added');
  if (state) btn.classList.add(state);
  if (label) {
    if (!label.dataset.default) label.dataset.default = label.textContent;
    label.textContent = msg || label.dataset.default;
  }
}

document.addEventListener('click', async (e) => {
  const btn = e.target.closest && e.target.closest('[data-fx-add]');
  if (!btn || btn.classList.contains('is-loading')) return;
  e.preventDefault();
  setBtnState(btn, 'is-loading');
  const r = await addToCart([{ id: btn.dataset.variantId, quantity: 1 }], btn);
  if (r.ok) {
    setBtnState(btn, 'is-added', 'Dodano!');
    setTimeout(() => setBtnState(btn, null), 2200);
  } else {
    setBtnState(btn, null, 'Brak w magazynie');
    setTimeout(() => setBtnState(btn, null), 2500);
  }
});

/* ---------- karta produktu renderowana w JS ---------- */
export function cardHTML(p) {
  const v = (p.variants || []).find((x) => x.available) || (p.variants || [])[0] || {};
  const price = v.price != null ? v.price : p.price;
  const cmp = v.compare_at_price || 0;
  const sale = cmp > price;
  const pct = sale ? Math.max(1, Math.floor(((cmp - price) * 100) / cmp)) : 0;
  const title = String(p.title || '').split('|')[0].trim();
  const imgs = (p.images || []).length ? p.images : p.featured_image ? [p.featured_image] : [];
  const needsLength = !!(p.fx_lengths && String(p.fx_lengths).trim());
  const single = (p.variants || []).length === 1 && !needsLength;
  const url = p.url || root + 'products/' + p.handle;
  const img1 = imgs[0] ? `<img class="fx-card__img" src="${imgUrl(imgs[0], 600)}" alt="${esc(title)}" loading="lazy" width="600" height="750">` : '';
  const img2 = imgs[1] ? `<img class="fx-card__img fx-card__img--alt" src="${imgUrl(imgs[1], 600)}" alt="" loading="lazy" width="600" height="750">` : '';
  let quick = '';
  if (p.available) {
    quick = single
      ? `<button type="button" class="fx-card__quick" data-fx-add data-variant-id="${v.id}" data-product-id="${p.id}" aria-label="Dodaj do koszyka: ${esc(title)}"><span class="fx-card__quick-icon" aria-hidden="true"><svg class="fx-i-plus" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg><svg class="fx-i-check" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12 5 5 9-10"/></svg><span class="fx-spinner"></span></span><span class="fx-card__quick-label">Dodaj do koszyka</span></button>`
      : `<a class="fx-card__quick" href="${url}"><span class="fx-card__quick-icon" aria-hidden="true"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h10M18 7h2M4 17h4M12 17h8"/><circle cx="16" cy="7" r="2"/><circle cx="10" cy="17" r="2"/></svg></span><span class="fx-card__quick-label">${needsLength ? 'Wybierz długość' : 'Wybierz opcje'}</span></a>`;
  }
  const badge = !p.available ? '<span class="fx-badge fx-badge--dark">Wyprzedane</span>' : sale ? `<span class="fx-badge fx-badge--sale">-${pct}%</span>` : '';
  const from = p.price_varies ? '<span class="fx-card__from">od</span>' : '';
  return `<article class="fx-card${p.available ? '' : ' fx-card--soldout'}">
    <div class="fx-card__visual">
      <a class="fx-card__media" href="${url}" tabindex="-1" aria-hidden="true">${img1}${img2}<span class="fx-card__badges">${badge}</span></a>
      ${FX.wishlist ? wlBtnHTML(p.handle, title) : ''}
      ${quick}
    </div>
    <div class="fx-card__info">
      <h3 class="fx-card__title"><a href="${url}">${esc(title)}</a></h3>
      <div class="fx-card__price">${from}<span class="fx-card__now${sale ? ' fx-card__now--sale' : ''}">${money(price)}</span>${sale ? `<s class="fx-card__was">${money(cmp)}</s>` : ''}</div>
    </div>
  </article>`;
}

const productCache = new Map();
export function fetchProduct(handle) {
  if (!productCache.has(handle)) {
    const base = root + 'products/' + encodeURIComponent(handle);
    productCache.set(
      handle,
      fetch(base + '?view=fx', { headers: { Accept: 'application/json' } })
        .then((r) => (r.ok ? r.text() : Promise.reject()))
        .then((t) => {
          const j = JSON.parse(t);
          if (!j || !j.handle) throw new Error('bad');
          return j;
        })
        .catch(() =>
          fetch(base + '.js', { headers: { Accept: 'application/json' } })
            .then((r) => (r.ok ? r.json() : null))
            .catch(() => null)
        )
    );
  }
  return productCache.get(handle);
}

/* =========================================================
   1. PASEK DARMOWEJ DOSTAWY
   ========================================================= */
class FxShipBar extends HTMLElement {
  static get observedAttributes() {
    return ['data-total'];
  }
  connectedCallback() {
    this._onCart = (cart) => this.setAttribute('data-total', cart.total_price);
    onCartChange(this._onCart);
    if (FX.cart) this.setAttribute('data-total', FX.cart.total_price);
    this.render();
  }
  disconnectedCallback() {
    cartListeners.delete(this._onCart);
  }
  attributeChangedCallback() {
    if (this.isConnected) this.render();
  }
  render() {
    const threshold = Number(this.dataset.threshold) || 0;
    const total = Number(this.dataset.total) || 0;
    if (!threshold) return;
    const left = Math.max(0, threshold - total);
    const pct = Math.min(100, Math.round((total / threshold) * 100));
    const text = this.querySelector('[data-fx-ship-text]');
    const fill = this.querySelector('[data-fx-ship-fill]');
    this.classList.toggle('is-done', left === 0);
    if (fill) fill.style.width = pct + '%';
    if (text) {
      text.innerHTML =
        left === 0
          ? '<strong>Masz darmową dostawę!</strong> Twoje zamówienie wyślemy bez kosztów.'
          : `Brakuje Ci <strong>${money(left)}</strong> do <strong>darmowej dostawy</strong>`;
    }
    this.setAttribute('aria-valuenow', String(pct));
    /* propozycje dobierane do brakującej kwoty */
    const items = [...this.querySelectorAll('[data-fx-upsell]')];
    const wrap = this.querySelector('[data-fx-upsell-wrap]');
    if (!items.length || !wrap) return;
    const inCart = new Set(((FX.cart && FX.cart.items) || []).map((i) => String(i.product_id)));
    items.forEach((el) => (el.hidden = true));
    if (left === 0) {
      wrap.hidden = true;
      return;
    }
    const candidates = items
      .filter((el) => !inCart.has(el.dataset.productId))
      .map((el) => ({ el, price: Number(el.dataset.price) }))
      .sort((a, b) => {
        const ao = a.price >= left ? 0 : 1, bo = b.price >= left ? 0 : 1;
        if (ao !== bo) return ao - bo;
        return ao === 0 ? a.price - b.price : b.price - a.price;
      })
      .slice(0, Number(this.dataset.max) || 2);
    candidates.forEach((c) => {
      c.el.hidden = false;
      c.el.parentNode.appendChild(c.el); /* kolejność: najpierw najlepsze dopasowanie */
    });
    wrap.hidden = candidates.length === 0;
  }
}
if (!customElements.get('fx-ship-bar')) customElements.define('fx-ship-bar', FxShipBar);

/* =========================================================
   7. LICZNIK WYSYŁKI
   ========================================================= */
function warsawNow(now) {
  const f = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Warsaw',
    year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,
  });
  const parts = Object.fromEntries(f.formatToParts(now).map((p) => [p.type, p.value]));
  return { y: +parts.year, m: +parts.month, d: +parts.day, h: +parts.hour % 24, min: +parts.minute, s: +parts.second };
}
function easter(y) {
  const a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25),
    g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4,
    l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451),
    month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(Date.UTC(y, month - 1, day));
}
const ymd = (dt) => dt.toISOString().slice(0, 10);
export function polishHolidays(y) {
  const fixed = ['01-01', '01-06', '05-01', '05-03', '08-15', '11-01', '11-11', '12-24', '12-25', '12-26'].map((d) => `${y}-${d}`);
  const e = easter(y);
  const add = (n) => ymd(new Date(e.getTime() + n * 86400000));
  return new Set([...fixed, add(0), add(1), add(49), add(60)]);
}
export function shippingInfo(now, cfg) {
  const t = warsawNow(now);
  const extra = new Set((cfg.daysOff || []).map((s) => s.trim()).filter(Boolean));
  const isShipDay = (dt) => {
    const dow = dt.getUTCDay();
    if (dow === 0) return false;
    if (dow === 6 && !cfg.saturday) return false;
    const key = ymd(dt);
    if (polishHolidays(dt.getUTCFullYear()).has(key) || extra.has(key)) return false;
    return true;
  };
  const today = new Date(Date.UTC(t.y, t.m - 1, t.d));
  const minutesNow = t.h * 60 + t.min;
  const cutoff = cfg.cutoff * 60;
  if (isShipDay(today) && minutesNow < cutoff) {
    const leftMin = cutoff - minutesNow - (t.s > 0 ? 1 : 0);
    return { today: true, hours: Math.floor(leftMin / 60), minutes: Math.max(0, leftMin % 60) };
  }
  let next = new Date(today.getTime() + 86400000);
  for (let i = 0; i < 14 && !isShipDay(next); i++) next = new Date(next.getTime() + 86400000);
  const diffDays = Math.round((next - today) / 86400000);
  const names = ['w niedzielę', 'w poniedziałek', 'we wtorek', 'w środę', 'w czwartek', 'w piątek', 'w sobotę'];
  const dd = String(next.getUTCDate()).padStart(2, '0') + '.' + String(next.getUTCMonth() + 1).padStart(2, '0');
  return { today: false, label: diffDays === 1 ? 'jutro' : names[next.getUTCDay()], date: dd };
}
class FxShipTimer extends HTMLElement {
  connectedCallback() {
    this.cfg = {
      cutoff: Number(this.dataset.cutoff) || 14,
      saturday: this.dataset.saturday === 'true',
      daysOff: (this.dataset.daysOff || '').split(/[\s,;]+/),
    };
    this.tick();
    this._t = setInterval(() => this.tick(), 30000);
  }
  disconnectedCallback() {
    clearInterval(this._t);
  }
  tick() {
    const info = shippingInfo(new Date(), this.cfg);
    const txt = this.querySelector('[data-fx-timer-text]');
    if (!txt) return;
    if (info.today) {
      const parts = [];
      if (info.hours > 0) parts.push(`${info.hours} ${plural(info.hours, 'godz.', 'godz.', 'godz.')}`);
      parts.push(`${info.minutes} min`);
      txt.innerHTML = `Zamów w ciągu <strong>${parts.join(' ')}</strong>, a <strong>wyślemy dziś</strong>`;
    } else {
      txt.innerHTML = `Zamów teraz – <strong>wyślemy ${info.label}</strong> (${info.date})`;
    }
    this.hidden = false;
  }
}
if (!customElements.get('fx-ship-timer')) customElements.define('fx-ship-timer', FxShipTimer);

/* =========================================================
   8a. ULUBIONE
   ========================================================= */
const WL_KEY = 'fx-wishlist';
export const wishlist = {
  all() {
    return store.get(WL_KEY, []);
  },
  has(h) {
    return this.all().includes(h);
  },
  toggle(h) {
    let list = this.all();
    const on = !list.includes(h);
    list = on ? [h, ...list].slice(0, 60) : list.filter((x) => x !== h);
    store.set(WL_KEY, list);
    syncWishlistUI();
    document.dispatchEvent(new CustomEvent('fx:wishlist', { detail: { handle: h, on, list } }));
    return on;
  },
};
function wlBtnHTML(handle, title) {
  const on = wishlist.has(handle);
  return `<button type="button" class="fx-wl-btn" data-fx-wl="${esc(handle)}" aria-pressed="${on}" aria-label="${on ? 'Usuń z ulubionych' : 'Dodaj do ulubionych'}: ${esc(title || '')}"><svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.3-9.6C1.5 7.4 3.8 4 7.2 4c2 0 3.6 1.1 4.8 2.8C13.2 5.1 14.8 4 16.8 4c3.4 0 5.7 3.4 4.5 6.9-1.8 5-9.3 9.6-9.3 9.6z"/></svg></button>`;
}
function syncWishlistUI() {
  const list = wishlist.all();
  document.querySelectorAll('[data-fx-wl]').forEach((b) => {
    const on = list.includes(b.dataset.fxWl);
    b.setAttribute('aria-pressed', String(on));
    const lbl = b.querySelector('[data-fx-wl-label]');
    if (lbl) lbl.textContent = on ? 'W ulubionych' : 'Dodaj do ulubionych';
    const al = b.getAttribute('aria-label') || '';
    b.setAttribute('aria-label', al.replace(/^(Usuń z ulubionych|Dodaj do ulubionych)/, on ? 'Usuń z ulubionych' : 'Dodaj do ulubionych'));
  });
  document.querySelectorAll('[data-fx-wl-count]').forEach((c) => {
    c.textContent = list.length;
    c.hidden = list.length === 0;
  });
}
document.addEventListener('click', (e) => {
  const b = e.target.closest && e.target.closest('[data-fx-wl]');
  if (!b) return;
  e.preventDefault();
  e.stopPropagation();
  const on = wishlist.toggle(b.dataset.fxWl);
  b.classList.remove('fx-pop');
  void b.offsetWidth;
  if (on) b.classList.add('fx-pop');
}, true);
window.addEventListener('storage', (e) => {
  if (e.key === WL_KEY) syncWishlistUI();
});
/* serduszka na kartach produktów motywu Horizon (kolekcje, wyszukiwarka, rekomendacje) */
function enhanceThemeCards(scope) {
  if (!FX.wishlist) return;
  (scope || document).querySelectorAll('product-card:not([data-fx-wl-ready])').forEach((card) => {
    card.setAttribute('data-fx-wl-ready', '');
    const link = card.querySelector('a.product-card__link[href*="/products/"]') || card.querySelector('a[href*="/products/"]');
    if (!link) return;
    const m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    if (!m) return;
    const wrap = document.createElement('div');
    wrap.innerHTML = wlBtnHTML(decodeURIComponent(m[1]), link.getAttribute('aria-label') || '');
    const btn = wrap.firstElementChild;
    btn.classList.add('fx-wl-btn--theme');
    card.appendChild(btn);
  });
}
/* 8a. strona z ulubionymi */
class FxWishlistGrid extends HTMLElement {
  connectedCallback() {
    this._h = () => this.render();
    document.addEventListener('fx:wishlist', this._h);
    this.render();
  }
  disconnectedCallback() {
    document.removeEventListener('fx:wishlist', this._h);
  }
  async render() {
    const grid = this.querySelector('[data-fx-grid]');
    const empty = this.querySelector('[data-fx-empty]');
    const count = this.querySelector('[data-fx-count]');
    const list = wishlist.all();
    if (count) count.textContent = list.length ? `${list.length} ${plural(list.length, 'produkt', 'produkty', 'produktów')}` : '';
    if (!list.length) {
      grid.innerHTML = '';
      empty.hidden = false;
      return;
    }
    empty.hidden = true;
    const products = (await Promise.all(list.map(fetchProduct))).filter(Boolean);
    /* usuń produkty, które już nie istnieją */
    if (products.length !== list.length) {
      const ok = new Set(products.map((p) => p.handle));
      store.set(WL_KEY, list.filter((h) => ok.has(h)));
    }
    grid.innerHTML = products.map((p) => `<div class="fx-grid__item">${cardHTML(p)}</div>`).join('');
    if (!products.length) empty.hidden = false;
  }
}
if (!customElements.get('fx-wishlist-grid')) customElements.define('fx-wishlist-grid', FxWishlistGrid);

/* =========================================================
   8b. OSTATNIO OGLĄDANE
   ========================================================= */
const RV_KEY = 'fx-recent';
if (FX.productHandle) {
  const list = store.get(RV_KEY, []).filter((h) => h !== FX.productHandle);
  store.set(RV_KEY, [FX.productHandle, ...list].slice(0, 16));
}
class FxRecent extends HTMLElement {
  async connectedCallback() {
    const limit = Number(this.dataset.limit) || 8;
    const list = store.get(RV_KEY, []).filter((h) => h !== FX.productHandle).slice(0, limit);
    if (!list.length) return;
    const products = (await Promise.all(list.map(fetchProduct))).filter(Boolean);
    if (!products.length) return;
    const track = this.querySelector('[data-fx-track]');
    track.innerHTML = products.map((p) => `<div class="fx-track__item">${cardHTML(p)}</div>`).join('');
    this.hidden = false;
    const clear = this.querySelector('[data-fx-recent-clear]');
    if (clear)
      clear.addEventListener('click', () => {
        store.set(RV_KEY, FX.productHandle ? [FX.productHandle] : []);
        this.hidden = true;
      });
  }
}
if (!customElements.get('fx-recent')) customElements.define('fx-recent', FxRecent);

/* =========================================================
   3. KALKULATOR ROZMIARU
   ========================================================= */
export function sizeAdvice(wrist, fitAdd, length, adjustable) {
  if (!(wrist > 0)) return null;
  const ideal = Math.round((wrist + fitAdd) * 2) / 2;
  if (!length) return { ideal, status: 'unknown' };
  if (adjustable) {
    return length >= wrist + 0.5 ? { ideal, status: 'adjustable' } : { ideal, status: 'tight' };
  }
  const diff = Math.round((length - ideal) * 10) / 10;
  if (Math.abs(diff) <= 0.75) return { ideal, status: 'perfect', diff };
  if (diff > 0) return { ideal, status: 'loose', diff };
  return { ideal, status: length >= wrist + 0.3 ? 'snug' : 'tight', diff };
}
class FxSizeGuide extends HTMLElement {
  connectedCallback() {
    const dlg = this.querySelector('dialog');
    const open = this.querySelector('[data-fx-size-open]');
    const form = this.querySelector('[data-fx-size-form]');
    const out = this.querySelector('[data-fx-size-out]');
    const hasCalc = !!(form && out);
    const length = parseFloat(String(this.dataset.length || '').replace(',', '.')) || 0;
    const adjustable = this.dataset.adjustable === 'true';
    open && open.addEventListener('click', () => (dlg.showModal ? dlg.showModal() : dlg.setAttribute('open', '')));
    this.querySelectorAll('[data-fx-size-close]').forEach((b) => b.addEventListener('click', () => dlg.close()));
    dlg.addEventListener('click', (e) => {
      if (e.target === dlg) dlg.close();
    });
    const calc = () => {
      if (!hasCalc) return;
      const w = parseFloat(String(form.wrist.value).replace(',', '.'));
      const fit = parseFloat(form.querySelector('[name="fit"]:checked').value);
      if (!(w >= 10 && w <= 30)) {
        out.hidden = !form.wrist.value;
        out.className = 'fx-size__out is-warn';
        out.innerHTML = 'Podaj obwód nadgarstka w centymetrach (zwykle 14–22 cm).';
        return;
      }
      const picker = document.querySelector('fx-length-picker');
      if (picker && picker.lengths && picker.lengths.length) {
        const ideal = Math.round((w + fit) * 2) / 2;
        const best = picker.closest_(ideal);
        const I2 = String(ideal).replace('.', ',');
        out.className = 'fx-size__out is-ok';
        out.innerHTML = best
          ? `Twoja idealna długość to ok. <strong>${I2} cm</strong>. Polecamy: <strong>${best} cm</strong>.<br><button type="button" class="fx-btn fx-btn--primary fx-size__pick" data-fx-size-pick="${best}">Wybierz ${best} cm</button>`
          : `Twoja idealna długość to ok. <strong>${I2} cm</strong> – nie mamy takiej długości w tym modelu. Napisz do nas, chętnie pomożemy.`;
        out.hidden = false;
        return;
      }
      const a = sizeAdvice(w, fit, length, adjustable);
      const L = String(length).replace('.', ',');
      const I = String(a.ideal).replace('.', ',');
      const map = {
        perfect: ['is-ok', `<strong>Ten model będzie pasować.</strong> Idealna długość dla Ciebie to ok. ${I} cm, a bransoletka ma ${L} cm.`],
        adjustable: ['is-ok', `<strong>Pasuje – ten model jest regulowany.</strong> Dopasujesz go do nadgarstka. Twoja idealna długość to ok. ${I} cm.`],
        loose: ['is-warn', `<strong>Będzie luźniejsza o ok. ${String(a.diff).replace('.', ',')} cm.</strong> Idealnie dla Ciebie: ${I} cm. Bransoletki z ogniwami można skrócić – napisz do nas przed zamówieniem.`],
        snug: ['is-warn', `<strong>Będzie dość dopasowana.</strong> Idealnie dla Ciebie: ${I} cm, a model ma ${L} cm. Jeśli lubisz luźniej, wybierz model regulowany.`],
        tight: ['is-bad', `<strong>Może być za ciasna.</strong> Model ma ${L} cm, a Twój nadgarstek ${String(w).replace('.', ',')} cm. Wybierz model dłuższy lub regulowany.`],
        unknown: ['is-ok', `Twoja idealna długość bransoletki to <strong>ok. ${I} cm</strong>. Porównaj ją z długością podaną w opisie.`],
      };
      const [cls, html] = map[a.status];
      out.className = 'fx-size__out ' + cls;
      out.innerHTML = html;
      out.hidden = false;
    };
    if (hasCalc) out.addEventListener('click', (e) => {
      const b = e.target.closest('[data-fx-size-pick]');
      if (!b) return;
      const picker = document.querySelector('fx-length-picker');
      if (picker) picker.select(b.dataset.fxSizePick, true);
      dlg.close();
    });
    if (hasCalc) form.addEventListener('input', calc);
    if (hasCalc) form.addEventListener('submit', (e) => {
      e.preventDefault();
      calc();
    });
    const print = this.querySelector('[data-fx-size-print]');
    print &&
      print.addEventListener('click', () => {
        const w = window.open('', '_blank');
        if (!w) return;
        let ticks = '';
        for (let mm = 0; mm <= 250; mm++) {
          const h = mm % 10 === 0 ? 8 : mm % 5 === 0 ? 5 : 3;
          ticks += `<line x1="${mm}" y1="0" x2="${mm}" y2="${h}" stroke="#000" stroke-width="0.2"/>`;
          if (mm % 10 === 0) ticks += `<text x="${mm}" y="12" font-size="3.2" text-anchor="middle" font-family="Arial">${mm / 10}</text>`;
        }
        w.document.write(`<!doctype html><html lang="pl"><head><meta charset="utf-8"><title>Miarka Ferale</title><style>@page{size:A4 landscape;margin:12mm}body{font-family:Arial,sans-serif;color:#1d1a17}h1{font-size:18px;margin:0 0 4mm}p{font-size:12px;margin:0 0 3mm;max-width:240mm}</style></head><body><h1>Miarka do bransoletki – Ferale</h1><p><b>Drukuj w skali 100% („Rzeczywisty rozmiar”), bez dopasowania do strony.</b> Sprawdź linijką, czy odcinek 0–10 cm ma dokładnie 10 cm.</p><p>Wytnij pasek, owiń wokół nadgarstka tuż za kością i odczytaj obwód. Do wyniku dodaj 1–2 cm luzu.</p><svg xmlns="http://www.w3.org/2000/svg" width="255mm" height="18mm" viewBox="-2 -2 255 18"><rect x="0" y="0" width="250" height="14" fill="none" stroke="#000" stroke-width="0.3" stroke-dasharray="1 1"/>${ticks}</svg><script>window.onload=function(){window.print()}<\/script></body></html>`);
        w.document.close();
      });
  }
}
if (!customElements.get('fx-size-guide')) customElements.define('fx-size-guide', FxSizeGuide);

/* =========================================================
   10. WYBÓR DŁUGOŚCI (jeden magazyn, długość w zamówieniu)
   ========================================================= */
const toNum = (v) => parseFloat(String(v).replace(',', '.'));
class FxLengthPicker extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('[data-fx-length-input]');
    this.valueEl = this.querySelector('[data-fx-length-value]');
    this.err = this.querySelector('[data-fx-length-error]');
    this.opts = [...this.querySelectorAll('[data-fx-length-opt]')];
    this.lengths = this.opts.map((o) => o.dataset.fxLengthOpt);
    this.linkForm();
    this.opts.forEach((o) =>
      o.addEventListener('click', () => this.select(o.dataset.fxLengthOpt))
    );
    this.querySelector('[role="radiogroup"]').addEventListener('keydown', (e) => {
      if (!['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'].includes(e.key)) return;
      e.preventDefault();
      const i = Math.max(0, this.lengths.indexOf(this.current));
      const d = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1;
      const n = this.lengths[(i + d + this.lengths.length) % this.lengths.length];
      this.select(n);
      this.opts.find((o) => o.dataset.fxLengthOpt === n).focus();
    });
    this.opts.forEach((o, i) => (o.tabIndex = i === 0 ? 0 : -1));
    const help = this.querySelector('[data-fx-length-help]');
    const sizeOpen = document.querySelector('[data-fx-size-open]');
    if (help && sizeOpen) {
      help.hidden = false;
      help.addEventListener('click', () => sizeOpen.click());
    }
    /* przywróć wybór, jeśli motyw przerysował blok */
    if (this.input && this.input.value) this.select(this.input.value.replace(/\s*cm$/, ''));
  }
  linkForm() {
    if (!this.input) return;
    let form = this.input.form;
    if (!form) {
      const sec = this.closest('.shopify-section') || document;
      form = sec.querySelector('form[data-type="add-to-cart-form"]') || document.querySelector('product-form-component form[data-type="add-to-cart-form"]');
      if (form) {
        /* uwaga: form.id może wskazywać pole <input name="id"> – używamy atrybutu */
        let fid = form.getAttribute('id');
        if (!fid) {
          fid = 'fx-product-form';
          form.setAttribute('id', fid);
        }
        this.input.setAttribute('form', fid);
      }
    }
    this.form = this.input.form || form || null;
  }
  closest_(ideal) {
    if (!this.lengths.length) return null;
    let best = null, bestD = Infinity;
    for (const l of this.lengths) {
      const d = Math.abs(toNum(l) - ideal);
      if (d < bestD - 1e-9 || (Math.abs(d - bestD) < 1e-9 && toNum(l) > toNum(best))) {
        best = l;
        bestD = d;
      }
    }
    return bestD <= 1.5 ? best : null;
  }
  select(val, scroll) {
    val = String(val).replace('.', ',');
    if (!this.lengths.includes(val)) return;
    this.current = val;
    this.opts.forEach((o) => {
      const on = o.dataset.fxLengthOpt === val;
      o.setAttribute('aria-checked', String(on));
      o.tabIndex = on ? 0 : -1;
    });
    if (this.input) this.input.value = val + ' cm';
    if (this.valueEl) this.valueEl.textContent = val + ' cm';
    this.classList.add('is-selected');
    if (this.err) this.err.hidden = true;
    this.classList.remove('is-error');
    if (scroll) this.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  isValid() {
    return !!(this.input && this.input.value);
  }
  showError() {
    if (this.err) this.err.hidden = false;
    this.classList.remove('is-error');
    void this.offsetWidth;
    this.classList.add('is-error');
    const r = this.getBoundingClientRect();
    if (r.top < 80 || r.bottom > window.innerHeight) this.scrollIntoView({ behavior: 'smooth', block: 'center' });
    const first = this.opts[0];
    if (first) first.focus({ preventScroll: true });
  }
}
if (!customElements.get('fx-length-picker')) customElements.define('fx-length-picker', FxLengthPicker);

/* blokada „Dodaj do koszyka” bez wybranej długości (przycisk główny, przyklejony pasek, Enter w formularzu) */
function pickerForForm(form) {
  if (!form) return null;
  return [...document.querySelectorAll('fx-length-picker')].find((p) => {
    if (!p.input) return false;
    if (!p.input.form) p.linkForm && p.linkForm();
    return p.input.form === form;
  });
}
function guard(e, form) {
  const picker = pickerForForm(form);
  if (picker && !picker.isValid()) {
    e.preventDefault();
    e.stopImmediatePropagation();
    picker.showError();
    return true;
  }
  return false;
}
document.addEventListener('click', (e) => {
  const btn = e.target.closest && e.target.closest('button[type="submit"], [ref="addToCartButton"]');
  if (!btn) return;
  const form = btn.form || btn.closest('form');
  guard(e, form);
}, true);
document.addEventListener('submit', (e) => guard(e, e.target), true);

/* ---------- okno informacyjne (np. „Potrzebuję skrócić bransoletkę”) ---------- */
class FxInfoDialog extends HTMLElement {
  connectedCallback() {
    const dlg = this.querySelector('dialog');
    const open = this.querySelector('[data-fx-info-open]');
    if (!dlg || !open) return;
    open.addEventListener('click', () => (dlg.showModal ? dlg.showModal() : dlg.setAttribute('open', '')));
    this.querySelectorAll('[data-fx-info-close]').forEach((b) => b.addEventListener('click', () => dlg.close()));
    dlg.addEventListener('click', (e) => {
      if (e.target === dlg) dlg.close();
    });
  }
}
if (!customElements.get('fx-info-dialog')) customElements.define('fx-info-dialog', FxInfoDialog);

/* =========================================================
   4. ODLICZANIE DO TERMINU (np. Święta)
   ========================================================= */
/* "2026-12-19 12:00" (czas polski) -> Date */
export function parseWarsawDate(str) {
  const m = String(str || '').trim().match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?$/);
  if (!m) return new Date(NaN);
  const [y, mo, d, h, mi] = [+m[1], +m[2], +m[3], m[4] == null ? 23 : +m[4], m[5] == null ? 59 : +m[5]];
  let guess = Date.UTC(y, mo - 1, d, h, mi) - 60 * 60000;
  for (let i = 0; i < 3; i++) {
    const t = warsawNow(new Date(guess));
    const deltaMin = (Date.UTC(y, mo - 1, d, h, mi) - Date.UTC(t.y, t.m - 1, t.d, t.h, t.min)) / 60000;
    if (deltaMin === 0) break;
    guess += deltaMin * 60000;
  }
  return new Date(guess);
}
class FxDeadline extends HTMLElement {
  connectedCallback() {
    this.deadline = parseWarsawDate(this.dataset.deadline);
    if (isNaN(this.deadline)) return;
    this.tick();
    this._t = setInterval(() => this.tick(), 1000);
  }
  disconnectedCallback() {
    clearInterval(this._t);
  }
  tick() {
    const diff = this.deadline - Date.now();
    const box = this.querySelector('[data-fx-countdown]');
    const after = [...this.querySelectorAll('[data-fx-after]')];
    const before = [...this.querySelectorAll('[data-fx-before]')];
    if (diff <= 0) {
      clearInterval(this._t);
      if (this.dataset.hideAfter === 'true' && !window.Shopify?.designMode) {
        const sec = this.closest('.shopify-section') || this;
        sec.hidden = true;
        sec.style.display = 'none';
        return;
      }
      if (box) box.hidden = true;
      before.forEach((el) => (el.hidden = true));
      after.forEach((el) => (el.hidden = false));
      return;
    }
    const s = Math.floor(diff / 1000);
    const vals = { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
    Object.entries(vals).forEach(([k, v]) => {
      const el = this.querySelector(`[data-fx-cd="${k}"]`);
      if (el) el.textContent = String(v).padStart(2, '0');
    });
    if (box) box.hidden = false;
  }
}
if (!customElements.get('fx-deadline')) customElements.define('fx-deadline', FxDeadline);

/* =========================================================
   5. QUIZ – ZNAJDŹ BRANSOLETKĘ
   ========================================================= */
export function quizScore(products, answers, styles) {
  const kw = (styles[answers.style] || []).map((k) => k.toLowerCase()).filter(Boolean);
  const [min, max] = answers.budget || [0, Infinity];
  return products
    .filter((p) => !answers.who || p.g.includes(answers.who))
    .map((p) => {
      const hay = (p.t + ' ' + (p.tags || '')).toLowerCase();
      const styleHit = kw.length ? kw.some((k) => hay.includes(k)) : false;
      const inBudget = p.p >= min * 100 && p.p <= max * 100;
      let score = 0;
      if (styleHit) score += 3;
      if (inBudget) score += 2;
      if (p.a) score += 1;
      if (p.c > p.p) score += 0.5;
      return { p, score, styleHit, inBudget };
    })
    .filter((x) => x.p.a)
    .sort((a, b) => b.score - a.score || a.p.p - b.p.p);
}
class FxQuiz extends HTMLElement {
  connectedCallback() {
    try {
      this.data = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
    } catch (e) {
      return;
    }
    this.answers = {};
    this.steps = [...this.querySelectorAll('[data-fx-step]')];
    this.bar = this.querySelector('[data-fx-quiz-fill]');
    this.addEventListener('click', (e) => {
      const opt = e.target.closest('[data-fx-answer]');
      if (opt) {
        const step = opt.closest('[data-fx-step]');
        const key = step.dataset.key;
        let val = opt.dataset.value;
        if (key === 'budget') val = val.split('-').map((n) => (n === 'inf' ? Infinity : Number(n)));
        this.answers[key] = val;
        step.querySelectorAll('[data-fx-answer]').forEach((b) => b.setAttribute('aria-pressed', String(b === opt)));
        setTimeout(() => this.go(this.steps.indexOf(step) + 1), 180);
      }
      if (e.target.closest('[data-fx-quiz-back]')) this.go(Math.max(0, this.current - 1));
      if (e.target.closest('[data-fx-quiz-restart]')) {
        this.answers = {};
        this.querySelectorAll('[data-fx-answer]').forEach((b) => b.setAttribute('aria-pressed', 'false'));
        this.go(0);
      }
    });
    this.go(0, true);
  }
  go(i, initial) {
    this.current = i;
    const total = this.steps.length - 1; /* ostatni krok = wynik */
    this.steps.forEach((s, n) => (s.hidden = n !== i));
    if (this.bar) this.bar.style.width = Math.round((Math.min(i, total) / total) * 100) + '%';
    const back = this.querySelector('[data-fx-quiz-back]');
    if (back) back.hidden = i === 0 || i === total;
    if (i === total) this.showResults();
    if (!initial) {
      const r = this.getBoundingClientRect();
      if (r.top < 0) this.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
  showResults() {
    const res = quizScore(this.data.products, this.answers, this.data.styles);
    const top = res.slice(0, 3);
    const grid = this.querySelector('[data-fx-results]');
    const note = this.querySelector('[data-fx-results-note]');
    const more = this.querySelector('[data-fx-results-more]');
    if (!top.length) {
      grid.innerHTML = '';
      note.textContent = 'Nie znaleźliśmy produktu dla tych odpowiedzi – zobacz wszystkie bransoletki.';
    } else {
      const exact = top.filter((x) => x.styleHit && x.inBudget).length;
      note.textContent = exact
        ? 'Na podstawie Twoich odpowiedzi polecamy:'
        : 'Nie mamy idealnego dopasowania, ale te modele są najbliżej Twoich odpowiedzi:';
      grid.innerHTML = top.map((x) => `<div class="fx-grid__item">${cardHTML(this.toCard(x.p))}</div>`).join('');
    }
    if (more) more.href = this.answers.who === 'him' ? this.data.urlHim : this.answers.who === 'her' ? this.data.urlHer : this.data.urlAll;
  }
  toCard(p) {
    return {
      id: p.id, handle: p.h, title: p.t, url: p.u, available: p.a, price: p.p, price_varies: p.pv, fx_lengths: p.l || '',
      images: p.i, variants: p.v ? [{ id: p.v, available: p.a, price: p.p, compare_at_price: p.c }] : [{}, {}].map(() => ({ available: p.a, price: p.p, compare_at_price: p.c })),
    };
  }
}
if (!customElements.get('fx-quiz')) customElements.define('fx-quiz', FxQuiz);

/* =========================================================
   6. ZESTAW DLA PARY
   ========================================================= */
class FxBundle extends HTMLElement {
  connectedCallback() {
    this.selects = [...this.querySelectorAll('[data-fx-bundle-variant]')];
    this.selects.forEach((s) => s.addEventListener('change', () => this.update()));
    this.lengthSelects = [...this.querySelectorAll('[data-fx-bundle-length]')];
    this.lengthSelects.forEach((s) => s.addEventListener('change', () => this.update()));
    this.btn = this.querySelector('[data-fx-bundle-add]');
    this.btn &&
      this.btn.addEventListener('click', async () => {
        if (this.btn.classList.contains('is-loading')) return;
        const items = this.selects.map((s) => {
          const item = s.closest('[data-fx-bundle-item]');
          const len = item && item.querySelector('[data-fx-bundle-length]');
          const it = { id: s.value, quantity: 1 };
          if (len && len.value) it.properties = { [len.dataset.label || 'Długość']: len.value + ' cm' };
          return it;
        });
        setBtnState(this.btn, 'is-loading', 'Dodaję…');
        const r = await addToCart(items, this.btn);
        if (r.ok) {
          setBtnState(this.btn, 'is-added', 'Zestaw w koszyku!');
          setTimeout(() => setBtnState(this.btn, null), 2600);
        } else {
          setBtnState(this.btn, null, 'Niedostępne – wybierz inny wariant');
          setTimeout(() => setBtnState(this.btn, null), 3000);
        }
      });
    this.update();
  }
  update() {
    let sum = 0, ok = true;
    this.selects.forEach((s) => {
      const opt = s.selectedOptions[0] || s.options[0];
      if (!opt) {
        ok = false;
        return;
      }
      sum += Number(opt.dataset.price) || 0;
      if (opt.dataset.available !== 'true') ok = false;
      const card = s.closest('[data-fx-bundle-item]');
      const priceEl = card && card.querySelector('[data-fx-bundle-price]');
      if (priceEl) priceEl.textContent = money(Number(opt.dataset.price));
    });
    const pct = Number(this.dataset.discount) || 0;
    const sumEl = this.querySelector('[data-fx-bundle-sum]');
    const totEl = this.querySelector('[data-fx-bundle-total]');
    const saveEl = this.querySelector('[data-fx-bundle-save]');
    const total = Math.round(sum * (1 - pct / 100));
    if (totEl) totEl.textContent = money(total);
    if (sumEl) {
      sumEl.textContent = money(sum);
      sumEl.hidden = pct === 0;
    }
    if (saveEl) {
      saveEl.textContent = `Oszczędzasz ${money(sum - total)}`;
      saveEl.hidden = pct === 0;
    }
    const missing = (this.lengthSelects || []).some((s) => !s.value);
    const hint = this.querySelector('[data-fx-bundle-hint]');
    if (hint) hint.hidden = !missing;
    if (this.btn) this.btn.disabled = !ok || missing;
  }
}
if (!customElements.get('fx-bundle')) customElements.define('fx-bundle', FxBundle);

/* ---------- start ---------- */
function boot(scope) {
  enhanceThemeCards(scope);
  syncWishlistUI();
}
boot();
new MutationObserver((muts) => {
  for (const m of muts) {
    for (const n of m.addedNodes) {
      if (n.nodeType === 1 && (n.matches('product-card') || n.querySelector('product-card') || n.querySelector('[data-fx-wl]'))) {
        boot(n.parentNode || document);
        return;
      }
    }
  }
}).observe(document.documentElement, { childList: true, subtree: true });
document.addEventListener('shopify:section:load', (e) => boot(e.target));
if (document.querySelector('fx-ship-bar')) refreshCart();
window.Ferale = { parseWarsawDate, money, wishlist, addToCart, refreshCart, shippingInfo, sizeAdvice, quizScore, polishHolidays, cardHTML };

/* =========================================================
   11. GALERIA ZDJĘĆ PRODUKTU (styl Allegro)
   ========================================================= */
const ZOOM_ATTR_RE = /(?:\/open\/|\/zoom\/)(\d+)/;
function bestSrc(img) {
  if (!img) return '';
  let url = img.currentSrc || img.src || '';
  const set = img.getAttribute('srcset');
  if (set) {
    let max = 0;
    set.split(',').forEach((part) => {
      const [u, w] = part.trim().split(/\s+/);
      const n = parseInt(w, 10) || 0;
      if (u && n >= max) {
        max = n;
        url = u;
      }
    });
  }
  if (url.startsWith('//')) url = 'https:' + url;
  return /[?&]width=\d+/.test(url) ? url.replace(/([?&])width=\d+/, '$1width=2400') : url + (url.includes('?') ? '&' : '?') + 'width=2400';
}
export function collectGallery(gallery) {
  const seen = new Map();
  gallery.querySelectorAll('[on\\:click]').forEach((el) => {
    const m = (el.getAttribute('on:click') || '').match(ZOOM_ATTR_RE);
    if (!m) return;
    const idx = Number(m[1]);
    if (seen.has(idx)) return;
    const box = el.closest('[class*="product-media-container--"]') || el;
    if (!/product-media-container--image/.test(box.className)) return;
    const img = box.querySelector('img');
    if (!img) return;
    seen.set(idx, { idx, src: bestSrc(img), thumb: img.currentSrc || img.src, alt: img.alt || '' });
  });
  return [...seen.values()].sort((a, b) => a.idx - b.idx);
}
class FxLightbox {
  constructor() {
    this.el = document.createElement('div');
    this.el.className = 'fx-lb fx-lb--' + (FX.galleryBg === 'dark' ? 'dark' : 'light');
    this.el.setAttribute('role', 'dialog');
    this.el.setAttribute('aria-modal', 'true');
    this.el.setAttribute('aria-label', 'Galeria zdjęć');
    this.el.hidden = true;
    this.el.innerHTML = `
      <div class="fx-lb__top"><span class="fx-lb__count" data-lb-count></span>
        <button type="button" class="fx-lb__btn fx-lb__close" data-lb-close aria-label="Zamknij galerię"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg></button></div>
      <div class="fx-lb__stage" data-lb-stage>
        <button type="button" class="fx-lb__btn fx-lb__nav fx-lb__nav--prev" data-lb-prev aria-label="Poprzednie zdjęcie"><svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg></button>
        <div class="fx-lb__frame" data-lb-frame><img class="fx-lb__img" data-lb-img alt="" draggable="false"><span class="fx-spinner fx-lb__spin" aria-hidden="true"></span></div>
        <button type="button" class="fx-lb__btn fx-lb__nav fx-lb__nav--next" data-lb-next aria-label="Następne zdjęcie"><svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg></button>
      </div>
      <div class="fx-lb__thumbs" data-lb-thumbs role="tablist" aria-label="Miniatury"></div>
      <p class="fx-lb__hint" data-lb-hint>Kliknij zdjęcie, aby przybliżyć</p>`;
    document.body.appendChild(this.el);
    const q = (s) => this.el.querySelector(s);
    this.img = q('[data-lb-img]');
    this.frame = q('[data-lb-frame]');
    this.count = q('[data-lb-count]');
    this.thumbs = q('[data-lb-thumbs]');
    this.hint = q('[data-lb-hint]');
    q('[data-lb-close]').addEventListener('click', () => this.close());
    q('[data-lb-prev]').addEventListener('click', () => this.go(this.i - 1));
    q('[data-lb-next]').addEventListener('click', () => this.go(this.i + 1));
    q('[data-lb-stage]').addEventListener('click', (e) => {
      if (e.target === e.currentTarget) this.close();
    });
    this.img.addEventListener('load', () => this.el.classList.remove('is-loading'));
    this.img.addEventListener('error', () => this.el.classList.remove('is-loading'));
    /* przybliżenie: klik = 2x w miejscu kliknięcia, ruch myszy przesuwa */
    this.frame.addEventListener('click', (e) => {
      if (this.moved) return;
      if (e.target !== this.img) return;
      this.toggleZoom(e);
    });
    this.frame.addEventListener('mousemove', (e) => this.zoomed && this.pan(e));
    /* gesty: przesunięcie palcem = następne/poprzednie */
    let sx = 0, sy = 0, st = 0;
    this.frame.addEventListener('touchstart', (e) => {
      if (e.touches.length !== 1) return;
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; st = Date.now(); this.moved = false;
    }, { passive: true });
    this.frame.addEventListener('touchmove', (e) => {
      if (e.touches.length !== 1 || this.zoomed) return;
      const dx = e.touches[0].clientX - sx;
      if (Math.abs(dx) > 8) { this.moved = true; this.img.style.transform = `translateX(${dx}px)`; }
    }, { passive: true });
    this.frame.addEventListener('touchend', (e) => {
      if (this.zoomed) return;
      const t = e.changedTouches[0];
      const dx = t.clientX - sx, dy = t.clientY - sy;
      this.img.style.transform = '';
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) && Date.now() - st < 800) this.go(this.i + (dx < 0 ? 1 : -1));
      setTimeout(() => (this.moved = false), 50);
    });
    this.onKey = (e) => {
      if (this.el.hidden) return;
      if (e.key === 'Escape') { e.preventDefault(); this.close(); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.i + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.i - 1); }
      else if (e.key === 'Tab') {
        const f = [...this.el.querySelectorAll('button')].filter((b) => !b.hidden && b.offsetParent !== null);
        if (!f.length) return;
        const first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    };
    document.addEventListener('keydown', this.onKey, true);
  }
  open(items, index, opener) {
    this.items = items;
    this.opener = opener;
    this.thumbs.innerHTML = items.map((it, n) => `<button type="button" class="fx-lb__thumb" role="tab" data-lb-thumb="${n}" aria-label="Zdjęcie ${n + 1} z ${items.length}"><img src="${esc(it.thumb)}" alt="" loading="lazy"></button>`).join('');
    this.thumbs.querySelectorAll('[data-lb-thumb]').forEach((b) => b.addEventListener('click', () => this.go(Number(b.dataset.lbThumb))));
    const single = items.length < 2;
    this.el.classList.toggle('is-single', single);
    this.el.hidden = false;
    document.documentElement.classList.add('fx-lb-open');
    requestAnimationFrame(() => this.el.classList.add('is-open'));
    this.go(Math.max(0, items.findIndex((x) => x.idx === index)));
    this.el.querySelector('[data-lb-close]').focus({ preventScroll: true });
  }
  close() {
    this.unzoom();
    this.el.classList.remove('is-open');
    this.el.hidden = true;
    document.documentElement.classList.remove('fx-lb-open');
    const o = this.opener;
    if (o) {
      const f = o.matches('button, a, [tabindex]') ? o : o.querySelector('button, a, [tabindex]');
      if (f) f.focus({ preventScroll: true });
    }
  }
  go(n) {
    if (!this.items || !this.items.length) return;
    const len = this.items.length;
    this.i = ((n % len) + len) % len;
    const it = this.items[this.i];
    this.unzoom();
    this.el.classList.add('is-loading');
    this.img.src = it.src;
    this.img.alt = it.alt;
    if (this.img.complete) this.el.classList.remove('is-loading');
    this.count.textContent = `${this.i + 1} / ${len}`;
    this.thumbs.querySelectorAll('[data-lb-thumb]').forEach((b, k) => {
      b.setAttribute('aria-selected', String(k === this.i));
      if (k === this.i) b.scrollIntoView({ block: 'nearest', inline: 'center' });
    });
    [1, -1].forEach((d) => {
      const nx = this.items[(this.i + d + len) % len];
      if (nx) new Image().src = nx.src;
    });
  }
  toggleZoom(e) {
    if (this.zoomed) return this.unzoom();
    this.zoomed = true;
    this.el.classList.add('is-zoomed');
    this.pan(e);
  }
  pan(e) {
    const r = this.frame.getBoundingClientRect();
    const x = Math.min(100, Math.max(0, ((e.clientX - r.left) / r.width) * 100));
    const y = Math.min(100, Math.max(0, ((e.clientY - r.top) / r.height) * 100));
    this.img.style.transformOrigin = `${x}% ${y}%`;
  }
  unzoom() {
    this.zoomed = false;
    this.el.classList.remove('is-zoomed');
    this.img.style.transformOrigin = '';
    this.img.style.transform = '';
  }
}
let lightbox = null;
window.addEventListener('click', (e) => {
  if (!FX.gallery) return;
  const trigger = e.target.closest && e.target.closest('[on\\:click]');
  if (!trigger) return;
  const m = (trigger.getAttribute('on:click') || '').match(ZOOM_ATTR_RE);
  if (!m) return;
  const gallery = trigger.closest('media-gallery');
  if (!gallery || trigger.closest('.dialog-zoomed-gallery, zoom-dialog')) return;
  const items = collectGallery(gallery);
  const idx = Number(m[1]);
  if (!items.some((x) => x.idx === idx)) return; /* film / model 3D – zostaw motywowi */
  e.preventDefault();
  e.stopImmediatePropagation();
  if (!lightbox) lightbox = new FxLightbox();
  lightbox.open(items, idx, trigger);
}, true);
window.Ferale.collectGallery = collectGallery;
